import React from 'react'
import classnames from 'classnames'

const FeatureSelectorItem = (props) => {
  return (
    <li
      key={props.index}
      className={classnames("tile", props.selectClass)}
      onClick={() => props.handleOnClick(props.option)}
    >
      <div className="row">
        <div className="feature-icon columns small-8 medium-4">
          <i className={props.option.icon}/>
          <h5 className="show-for-small-only">{ props.option.label }</h5>
        </div>
        <div className="feature-description columns small-8 medium-12">
          <h5 className="hide-for-small-only">{ props.option.label }</h5>
          <p>{ props.option.description }</p>
        </div>
      </div>
    </li>
  );
};

const BinarySelectorItem = React.createClass({
  getInitialState: function(){
    return({
      value: []
    })
  },

  handleOnClick: function(choice) {
    // get possible choices
    const choices = this.props.option;
    let chosen = this.props.optionList;

    // see if choice is already chosen
    const choiceInChosen = chosen.find(i => i.field === choice.field);
    // remove both choices
    chosen = chosen.filter(o => !choices.map(c => c.field).includes(o.field));
    // if not, add it
    if(!choiceInChosen){
      chosen = chosen.concat(choice);
    }

    this.props.onChange(chosen);
  },

  render: function() {
    const option = this.props.option;
    const choiceOneClass = classnames("choice", this.props.selectClass[0]);
    const choiceTwoClass = classnames("choice", this.props.selectClass[1]);

    return (
      <li key={this.props.index}>
        <div className={classnames("tile", choiceOneClass)} onClick={() => this.handleOnClick(option[0])}>
          <h4>{option[0].label}</h4>
        </div>
        <div className="separator">or</div>
        <div className={classnames("tile", choiceTwoClass)} onClick={() => this.handleOnClick(option[1])}>
          <h4>{option[1].label}</h4>
        </div>
      </li>
    );
  }
});

// Feature / style selector field
class Selector extends React.Component {
  constructor(props) {
    super(props);

    this.renderChoiceTiles = this.renderChoiceTiles.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick(option) {
    let optionList = this.props.input.value || [];
    const optionIndex = optionList.findIndex(o => o.label === option.label);

    if (optionIndex >= 0) {
      optionList = optionList.filter((o, i) => i !== optionIndex);
    } else {
      optionList = optionList.concat(option);
    }

    this.props.input.onChange(optionList);
  }

  renderChoiceTiles(options, handleOnClick) {
    var isFeatureSelector = this.props.isFeatureSelector;
    var optionList = this.props.input.value || [];
    var inputOnChange = this.props.input.onChange;

    return (
      options.map(function(option, i){
        if(isFeatureSelector) {
          var optLabel = option.label.toLowerCase().replace(' ', '-'), optValues = option.label;
          var selectClass = classnames({
            "selected": optionList.find(o => o.label === option.label)
          });
        } else {
          var optLabel = option[0].label.toLowerCase() + "-" + option[1].label.toLowerCase();
          var selectClass = [
            classnames({
              "selected": optionList.find(o => o.field === option[0].field)
            }),
            classnames({
              "selected": optionList.find(o => o.field === option[1].field)
            }),
          ];
        }

        return (
          isFeatureSelector ?
            <FeatureSelectorItem
              option={option}
              selectClass={selectClass}
              index={i}
              key={i}
              handleOnClick={handleOnClick}
            /> :
            <BinarySelectorItem
              onChange={inputOnChange}
              option={option}
              selectClass={selectClass}
              index={i}
              key={i}
              handleOnClick={handleOnClick}
              optionList={optionList}
            />
        );
      })
    )
  }

  render(){
    const { options } = this.props;
    return (
      <ul className={classnames("features-selector", {"binary-selector": !this.props.isFeatureSelector})}>
        { this.renderChoiceTiles(options, this.handleOnClick) }
      </ul>
    );
  }
}

export const FeatureSelector = (props) => {
  return <Selector {...props} isFeatureSelector={true} />
}

export const BinarySelector = (props) => {
  return <Selector {...props} isFeatureSelector={false} />
}




// WEBPACK FOOTER //
// ./pap/components/common/input_fields/feature_selector.jsx